/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyListCtrl
 */
angular.module('mercury.modules.settings.company')
  .controller('SettingsCompanyListCtrl', ["Company", "LoadedSubscription", "LoadedInvoice", "$filter", "$scope", "$http", "title", "$state", "$window", "$q", "userinfo", "dialog", "localStorageService", "settings", "companyChange", function(Company, LoadedSubscription, LoadedInvoice, $filter, $scope, $http, title,
      $state, $window, $q, userinfo, dialog, localStorageService, settings, companyChange) {

    $scope.loading = $q.all({
      companies: Company.getAll(),
      mySubscriptions: LoadedSubscription.getAll(),
      invoices: LoadedInvoice.getAll()
    });

    var pos = (localStorageService.get('signup-pos')) ? localStorageService.get('signup-pos') : false;
    var coCreate = (localStorageService.get('company-created')) ? localStorageService.get('company-created') : false;
    if (pos && !coCreate) {
      $state.go('Settings.CompanyImporter');
    } else if (pos && coCreate) {
      localStorageService.remove('signup-pos');
      localStorageService.remove('company-created');
      $state.go('Stock.ReportOverview', {}, {reload: true});
    }

    var userDetails = userinfo.userDetails();

    // todo: remove this manual feature gate once users are allowed to see the new page
    $scope.ViewReactPage = userDetails.email.endsWith('@loadedreports.com') || userinfo.userDetails().email.endsWith('@loadedhub.com');

    $scope.user = {
      name: userDetails.firstName,
      lastName: userDetails.lastName,
      userName: userDetails.email,
      logins: userDetails.logins,
      hasPassword: userDetails.hasPassword
    };

    $scope.loading.then(function(result) {
      $scope.mySubscriptions = result.mySubscriptions;
      $scope.allCompanies = result.companies;
      $scope.invoices = result.invoices.data.sort(function(a, b) {
        return new Date(b.sequenceNumber) < new Date(a.sequenceNumber) ? 1 : -1;
      });

      // Decorate mySubscriptions with company codes, eventaully
      // we should include the data in the API response, but the
      // API needs a redesign for the page in general.
      $scope.mySubscriptions = $scope.mySubscriptions.map(function(sub) {
        sub.companies = sub.companies.map(function(comp) {
          const company = result.companies.find(function(company) {
            return company.id === comp.id;
          });
          return company ? Object.assign(comp, { code: company.code }) : comp;
        });

        return sub;
      });

      // filter out companies that we own
      $scope.otherCompanies = result.companies.filter(function(item) {
        return result.mySubscriptions.filter(function(sub) {
          return sub.companies.filter(function(comp) {
            return comp.id == item.id;
          }).length > 0;
        }).length === 0;
      });

      // If there are any companies with a migration date, this user is considered legacy.
      $scope.legacyUser = $filter('filter')(result.companies, {
        migrationDate: ''
      }).length > 0;

      // ------ INVOICE TABLE START ------ //
      $scope.sort = {
        sortingOrder: 'id',
        reverse: true
      };

      $scope.gap = 3;

      $scope.filteredItems = [];
      $scope.groupedItems = [];
      $scope.itemsPerPage = 10;
      $scope.pagedItems = [];
      $scope.currentPage = 0;

      var searchMatch = function(haystack, needle) {
        if (!needle) {
          return true;
        }
        return haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1;
      };

      // init the filtered items
      $scope.search = function() {
        $scope.filteredItems = $filter('filter')($scope.invoices, function(item) {
          for (var attr in item) {
            if (searchMatch(item[attr], $scope.query)) { return true; }
          }
          return false;
        });
        // take care of the sorting order
        if ($scope.sort.sortingOrder !== '') {
          $scope.filteredItems = $filter('orderBy')($scope.filteredItems, $scope.sort.sortingOrder, $scope.sort.reverse);
        }
        $scope.currentPage = 0;
        // now group by pages
        $scope.groupToPages();
      };

      // calculate page in place
      $scope.groupToPages = function() {
        $scope.pagedItems = [];

        for (var i = 0; i < $scope.filteredItems.length; i++) {
          if (i % $scope.itemsPerPage === 0) {
            $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)] = [$scope.filteredItems[i]];
          } else {
            $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)].push($scope.filteredItems[i]);
          }
        }

        for (var j = 0; j < $scope.pagedItems.length; j++) {
          $scope.pagedItems[j].reverse();
        }
      };

      $scope.range = function(size, start, end) {

        if ($scope.pagedItems.length <= 3) {
          $scope.gap = $scope.pagedItems.length;
        }

        var ret = [];

        if (size < end) {
          end = size;
          start = size - $scope.gap;
        }

        for (var i = start; i < end; i++) {
          ret.push(i);
        }

        return ret;
      };

      $scope.prevPage = function() {
        if ($scope.currentPage > 0) {
          $scope.currentPage--;
        }
      };

      $scope.nextPage = function() {
        if ($scope.currentPage < $scope.pagedItems.length - 1) {
          $scope.currentPage++;
        }
      };

      $scope.setPage = function() {
        $scope.currentPage = this.n;
      };

      // functions have been describe process the data for display
      $scope.search();

      // ------ INVOICE TABLE END ------ //
    });

    title.set('Account');

    $scope.openBillingPortal = function(subscriptionId) {
      // fetch the billing url from the server
      $http.get(settings.apiHost + '/r/BillingPortal', {
          params: {
            subscriptionId: subscriptionId
          }
        })
        .then(function(result) {
          $window.open(result.data, '_blank');
        });
    };

    $scope.showTick = function(dateCheck) {
      if (dateCheck != null) {
        var oneDay = 24 * 60 * 60 * 1000;
        var nDate = new Date(dateCheck);
        var today = new Date();
        var diffDays = Math.round(Math.abs((nDate.getTime() - today.getTime()) / (oneDay)));
        // console.log(oneDay);
        // console.log(nDate.getTime());
        // console.log(today.getTime());
        // console.log(diffDays < 1000);
        return (diffDays < 1);
      } else {
        return false;
      }
    };

    $scope.daysSinceConnection = function(dateCheck) {
      if (dateCheck != null) {
        var oneDay = 24 * 60 * 60 * 1000;
        var nDate = new Date(dateCheck);
        var today = new Date();
        var diffDays = Math.round(Math.abs((nDate.getTime() - today.getTime()) / (oneDay)));
        // console.log(oneDay);
        // console.log(nDate.getTime());
        // console.log(today.getTime());
        // console.log(diffDays < 1000);
        return diffDays;
      } else {
        return -1;
      }
    };

    $scope.viewCompanyPermissions = function(company) {
      createCompanyModal = dialog.open({
        controller: 'SettingsCompanyViewPermissionsCtrl',
        templateUrl: 'modules/settings/company/viewpermissions.tpl.html',
        resolve: {
          companyInfo: function() {
            return {
              userPermissions: company.permissions,
              companyName: company.shortName
            };
          }
        }
      });
    };

    $scope.navigateToReactPreferencesPage = function(company) {
      companyChange.changeCompanyAndNavigate(company, 'Settings.CompanyPreferencesReact');
    };

    $scope.copyToClipboard = function(event, text) {
      navigator.clipboard.writeText(text);
      event.target.classList.add('clicked');
      setTimeout(() => {
        event.target.classList.remove('clicked');
      }, 200);
    };
  }]);
